import React, {PropTypes} from 'react';

import classNames from 'classnames';

import CapacityAvailabilityFormContainer from './CapacityAvailabilityFormContainer.jsx';

const CapacityAvailabilityModal = ({
  title,
  visible,
  onCloseClick
}) => (
  <div
    className={classNames(
      "modal",
      {"display block animated fadeIn": visible}
    )}
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <button
            type="button"
            className="close"
            aria-hidden="true"
            onClick={onCloseClick}
          >&times;</button>
          <h4 className="modal-title">{title}</h4>
        </div>
        <div className="modal-body">
          <div className="flex center animated fadeIn">
            <div className="col-xs-12 col-lg-10">
              <div className="row">
                <CapacityAvailabilityFormContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

CapacityAvailabilityModal.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onCloseClick: PropTypes.func
};

export default CapacityAvailabilityModal;



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/CapacityAvailabilityModal.jsx